import { Plugin, PluginKey } from 'prosemirror-state'
import { handlePaste } from 'proseShared/plugins/PastePlugin/utils'
import { QueryClient } from 'react-query'

const PastePluginKey = new PluginKey('InputPastePlugin')

export const PastePlugin = (queryClient: QueryClient) =>
  new Plugin({
    key: PastePluginKey,
    props: {
      handlePaste: handlePaste(queryClient),
    },
  })
